import { initializeApp } from "firebase/app";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { toast } from "react-hot-toast";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_apikey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId,
};

// Initialized App
const app = initializeApp(firebaseConfig);

// Firebase storage
export const storage = getStorage(app);

// Firebase database
const db = getFirestore();

// sign up with metamask
export const signUpMetamask = async () => {
  //input error handling
  const tronWeb = window.tronLink;
  if (tronWeb) {
    try {
      // Will open the MetaMask UI
      await tronWeb.request({
        method: "tron_requestAccounts",
      });
      var currentaddress = await window.tronWeb.defaultAddress.base58;

      const addy = await window.tronWeb.address.toHex(currentaddress);
      console.log(addy);
      // check if the google account has gone through onboarding or not

      const querySnapShot = await getDocs(collection(db, "users"));
      let array = [];
      querySnapShot.forEach((user) => {
        const { id } = user;
        array.push(id);
      });
      let account = addy;
      // check if the user exist
      let isCreated = array.includes(account);
      return { isCreated, account };
    } catch (error) {
      toast.error(`❌ ${error.message}`);
      console.error(error);
    }
  }
};

// adding personal details setup to firebase
export const addSetupDetailsPersonal = async (uid, values) => {
  const { name, url, businessLogoUrl, phone } = values;
  const getDocRef = doc(db, "users", uid);
  try {
    await setDoc(getDocRef, {
      acct: "per",
      name: name,
      address: uid,
      username: "",
      insta: "",
      fb: "",
      tw: url,
      companies: [],
      phone: phone,
      businessLogoUrl: businessLogoUrl,
      email: uid,
      report: [],
      transactions: [],
    });
  } catch (error) {
    toast.error(`❌ ${error.message}`);
  }
};

// adding business details setup to firebase
export const addSetupDetailsBusiness = async (uid, values) => {
  const getDocRef = doc(db, "users", uid);
  const {
    companyName,
    businessLogoUrl,
    companyAddress,
    businessType,
    selectedCountry,
    telephone,
    website,
    createdAt,
  } = values;
  try {
    await setDoc(getDocRef, {
      acct: "com",
      companyName: companyName,
      companyAddress: companyAddress,
      businessType: businessType,
      businessLogoUrl: businessLogoUrl,
      selectedCountry: selectedCountry,
      telephone: telephone,
      website: website,
      createdAt: createdAt,
      department: [],
      employee: [],
      notifications: [],
      address: "",
      report: [],
      transactions: [],
      email: uid,
    }).then(() => {
      return (window.location.pathname = "/dashboard");
    });
  } catch (error) {
    console.log(error);
    toast.error(`❌ ${error.message}`);
  }
};

// get user details
export const getUser = async (wallet) => {
  const getDocRef = doc(db, "users", wallet);
  const docSnap = await getDoc(getDocRef);
  if (docSnap.exists()) {
    let userData = docSnap.data();
    return { userData };
  } else {
    let userData = null;
    console.log("No document!");
    return { userData };
  }
};

// create an employee
export const createEmployeee = async (
  wallet,
  values,
  payid,
  transactionHash1,
  transactionHash,
  status1,
  department
) => {
  const docRef = doc(db, "users", wallet);
  const docSnap = await getDoc(docRef);

  // check if doc exist
  if (docSnap.exists()) {
    // get array from firebase firestore
    const arrayItem = docSnap.data()?.employee;
    const transactions = docSnap.data()?.transactions;

    const date = new Date().toISOString().split("T")[0];
    // push new details to various array
    transactions.push({
      address: values.address,
      date: `${date.toString()}`,
      amount: values.salary,
      transactionHash: transactionHash,
      employee: values.name,
      status: true,
      details: "Plan Creation",
    });

    arrayItem.push({
      address: values.address,
      payid: payid,
      name: values.name,
      salary: values.salary,
      startdate: values.startdate,
      department: department,
      payday: values.payday,
    });

    transactions.push({
      address: values.address,
      date: `${date.toString()}`,
      amount: values.salary,
      transactionHash: transactionHash1,
      employee: values.name,
      status: status1,
      details: "Plan Subcription",
    });
    await updateDoc(docRef, {
      employee: arrayItem,
      transactions: transactions,
    }).then(() => console.log("done p"));
  } else {
    console.log("No document!");
  }
};

// update personal transactions
export const updateTransactions = async (
  email,
  values,
  transactionHash,
  status
) => {
  // get doc reference
  const docRef = doc(db, "users", email);
  const docSnap = await getDoc(docRef);

  // check if doc exist
  if (docSnap.exists()) {
    // get the personal transactions array
    const arrayItem = docSnap.data()?.transactions;
    const date = new Date().toISOString().split("T")[0];
    // push the new transactions to the array
    arrayItem.push({
      date: `${date.toString()}`,
      address: values.address,
      amount: values.amount,
      employee: "Gift transaction",
      status: status,
      transactionHash: transactionHash,
      details: "Sending trx",
    });

    // update the firebase personal transactions array with the new one
    await updateDoc(docRef, {
      transactions: arrayItem,
    }).then(() => console.log("done"));
  } else {
    console.log("No document!");
  }
};

// update personal transactions
export const updateReport = async (wallet, values) => {
  // get doc reference
  const docRef = doc(db, "users", wallet);
  const docSnap = await getDoc(docRef);

  // check if doc exist
  if (docSnap.exists()) {
    // get the report array
    const arrayItem = docSnap.data()?.report;

    // push the new report to the array
    arrayItem.push({
      title: values.title,
      des: values.des,
      date: new Date().toISOString().split("T")[0],
    });

    // update the firebase report array with the new one
    await updateDoc(docRef, {
      report: arrayItem,
    }).then(() => console.log("done"));
  } else {
    console.log("No document!");
  }
};

// update transaction when user paid
export const updateT = async (email, transactionHash, status, name, salary) => {
  const docRef = doc(db, "users", email);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const transactions = docSnap.data()?.transactions;

    const date = new Date().toISOString().split("T")[0];
    transactions.push({
      date: `${date.toString()}`,
      amount: salary,
      address: email, //change to user address
      transactionHash: transactionHash,
      employee: name,
      status: status,
      details: "Salary",
    });

    await updateDoc(docRef, {
      transactions: transactions,
    }).then(() => console.log("done"));
  } else {
    console.log("No document!");
  }
};

export const checkIfUserExist = async (address) => {
  const querySnapShot = await getDocs(collection(db, "users"));
  let array = [];
  querySnapShot.forEach((user) => {
    const { id } = user;
    array.push(id);
  });
  let account = address;
  let isCreated = array.includes(account);
  return isCreated;
};

export const getCompanies = async () => {
  const querySnapShot = await getDocs(collection(db, "users"));
  let array = [];
  querySnapShot.forEach((user) => {
    let acctType = user.get("acct");
    if (acctType == "com") {
      const { id } = user;
      array.push(id);
    }
  });
  let companies = [];
  for (let index = 0; index < array.length; index++) {
    const docRef = doc(db, "users", array[index]);
    const docSnap = await getDoc(docRef);
    companies.push(docSnap.data());
  }
  return { companies };
};

export const getUsers = async () => {
  const querySnapShot = await getDocs(collection(db, "users"));
  let array = [];
  querySnapShot.forEach((user) => {
    let acctType = user.get("acct");
    if (acctType == "per") {
      const { id } = user;
      array.push(id);
    }
  });
  let companies = [];
  for (let index = 0; index < array.length; index++) {
    const docRef = doc(db, "users", array[index]);
    const docSnap = await getDoc(docRef);
    companies.push(docSnap.data());
  }
  return { companies };
};

export const addToEmployee = async (
  address,
  values,
  logo,
  name,
  payId,
  addy,
  department
) => {
  let isUser = await checkIfUserExist(address);
  if (isUser) {
    const docRef = doc(db, "users", address);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const array = docSnap.data()?.companies;
      array.push({
        company: name,
        logo: logo,
        role: department,
        salary: values?.salary,
        payday: values?.payid,
        startDate: values?.startdate,
        payId: payId,
        companyAddy: addy,
      });
      await updateDoc(docRef, {
        companies: array,
      }).then(() => console.log("done"));
    }
  }
};
export const sendNotification = async (
  address,
  sender,
  logo,
  name,
  details
) => {
  let isUser = await checkIfUserExist(address);
  if (isUser) {
    const docRef = doc(db, "users", address);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const array = docSnap.data()?.notifications;
      array.push({
        name: name,
        logo: logo,
        sender: sender,
        details: details,
      });
      await updateDoc(docRef, {
        notifications: array,
      }).then(() => console.log("done"));
      let sent = true;
      return { sent };
    }
  }
};

export const createDepartment = async (departmentName, wallet) => {
  const docRef = doc(db, "users", wallet);
  const docSnap = await getDoc(docRef);

  // check if doc exist
  try {
    if (docSnap.exists()) {
      // get array from firebase firestore
      const arrayItem = docSnap.data()?.department;
      // push new details to various array
      arrayItem.push(departmentName);
      await updateDoc(docRef, {
        department: arrayItem,
      }).then(() => console.log("done p"));
    } else {
      console.log("No document!");
    }
  } catch (error) {
    console.log(error);
  }
};
